import vi from 'date-fns/locale/vi';
import React, { PureComponent } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import '../../../node_modules/react-datepicker/dist/react-datepicker.css';

registerLocale('vi', vi);

export default class DatePickerReact extends PureComponent {
  /**
   *triggerChange: gọi hàm onChange từ props để xử lý
   *@param {string} changedValue
   * @memberof DatePickerReact
   */
  triggerChange = (changedValue) => {
    // eslint-disable-next-line react/prop-types
    const { onChange } = this.props;
    if (onChange) {
      onChange(changedValue);
    }
  };

  /**
   *handleDateChange: hàm thay đổi ngày
   *@param {string} date
   * @memberof DatePickerReact
   */
  handleDateChange = (date) => {
    this.triggerChange(date);
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { value } = this.props;
    return (
      <div className="rdp-wrapper">
        {/* <Icon className="icon-calendar" type="calendar" /> */}
        <DatePicker
          className="input-date-custom"
          dateFormat="dd/MM/yyyy"
          isClearable
          locale="vi"
          onChange={this.handleDateChange}
          placeholderText="Nhập ngày"
          // eslint-disable-next-line react/prop-types
          selected={value || undefined}
          style={{ width: '100%' }}
        />
      </div>
    );
  }
}
